import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-x-icon/jb-x-icon.css.ts
var jb_x_icon_css_default = i`:host{display:block;height:var(--icon-height, 13.9px);width:var(--icon-width, 15.4px)}svg{height:var(--icon-height, 13.9px);width:var(--icon-width, 15.4px)}`;

export {
  jb_x_icon_css_default
};
